import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

import { types } from './actions.js';
import conf from '../../../shared/conf.js';

const initialState = {
  user: null,
  freelance: null,
  loading: 0,
  notConnected: true,
  loader: true,
  endLoading: false,
};

export default function reducer(state = initialState, action) {
  if (action.type === types.SET_CURRENT_USER) {
    if (action.user.isInternal) {
      ReactGA.set({dimension2: 'internal'});
      ReactGA4.set({dimension2: 'internal'});
    } else {
      if (action.user.account_type === conf.accountTypes.freelance) {
        ReactGA.set({dimension2: 'freelance'});
        ReactGA4.set({dimension2: 'freelance'});
      } else if (action.user.account_type === conf.accountTypes.do) {
        ReactGA.set({dimension2: 'DO'});
        ReactGA4.set({dimension2: 'DO'});
      }
    }

    return {
      ...state,
      user: {
        ...action.user,
        hasMeetingScheduled: (state && state.user && state.user.hasMeetingScheduled) || action.user.hasMeetingScheduled
      }
    };
  } else if (action.type === types.SET_MEETING_SCHEDULED) {
    return {
      ...state,
      user: {
        ...state.user,
        hasMeetingScheduled: action.hasMeetingScheduled
      }
    }
  } else if (action.type === types.REMOVE_CURRENT_USER) {
    ReactGA.set({ dimension2: null });
    ReactGA4.set({ dimension2: null });
    return {
      ...state,
      user: null,
    };
  } else if (action.type === types.SET_CURRENT_FREELANCE) {
    return {
      ...state,
      freelance: action.freelance
    };
  } else if (action.type === types.START_LOADING) {
    return {
      ...state,
      loading: state.loading + 1
    };
  } else if (action.type === types.STOP_LOADING) {
    return {
      ...state,
      loading: state.loading - 1,
      endLoading: true,
    };
  } else if(action.type === types.CURRENT_USER_NOT_CONNECTED) {
    ReactGA.set({dimension2: 'guest'});
    ReactGA4.set({dimension2: 'guest'});

    return {
      ...state,
      connected: true,
    }
  } else if(action.type === types.CANCEL_LOADER) {
    return {
      ...state,
      loader: false,
    }
  }
  return state;
}